import { cn } from "@/lib/utils";
import { useNavigationState } from "hooks/useNavigationState";
import { useTagRouting } from "hooks/useTagRouting";
import { AppPage } from "models/AppPage";

import { NavItem } from "./navigation/NavItem";

interface DesktopNavProps {
    pages: AppPage[];
    className?: string;
}

export const DesktopNav = ({ pages, className }: DesktopNavProps) => {
    // Filter out customer service from navigation
    // const filteredPages = pages.filter((page) => page.label !== "고객센터");
    const filteredPages = pages;

    // Custom hooks for state and routing logic
    const {
        activeDropdown,
        setActiveDropdown,
        currentTag,
        isOnTagRoute,
        isPageActive
    } = useNavigationState(filteredPages);

    const { getDisplayLabel } = useTagRouting(isOnTagRoute);

    return (
        <nav className={cn("hidden items-center gap-1 lg:flex", className)}>
            {filteredPages.map((page, index) => {
                const hasChildren = page.children && page.children.length > 0;
                const isDropdownActive = activeDropdown === page.label;

                return (
                    <NavItem
                        key={`${page.label}-${index}`}
                        page={page}
                        index={index}
                        isPageActive={isPageActive(page)}
                        isDropdownActive={isDropdownActive}
                        displayLabel={getDisplayLabel(page, currentTag)}
                        currentTag={currentTag}
                        onMouseEnter={() =>
                            hasChildren && setActiveDropdown(page.label)
                        }
                        onMouseLeave={() => setActiveDropdown(null)}
                    />
                );
            })}
        </nav>
    );
};
